module.exports = __webpack_public_path__ + "img/medical_expenses_icon.e286ddba.png";